import {
  useGetSupplyDemandReport,
  useGetWeeklyPlanningReport,
  useGetWeeklyProgramUtilizationReport,
  useGetWeeklySpecialistsReport,
} from './usePlanning'
import { useAcceptShiftExtension } from './useShiftExtension'

export const planning = {
  getWeeklyPlanningReport: useGetWeeklyPlanningReport,
  getWeeklySpecialistsReport: useGetWeeklySpecialistsReport,
  getProgramUtilizationReport: useGetWeeklyProgramUtilizationReport,
  getSupplyDemandReport: useGetSupplyDemandReport,
  acceptShiftExtension: useAcceptShiftExtension,
}
